import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AdminMobileNav } from "@/components/admin/admin-mobile-nav";

export const Route = createFileRoute("/_authenticated/admin")({
  beforeLoad: ({ context }) => {
    const user = (context as { user?: { role?: string | null } }).user;
    if (user?.role !== "admin" && user?.role !== "div_admin") {
      throw redirect({ to: "/" });
    }
  },
  component: AdminLayout,
});

function AdminLayout() {
  const { user } = Route.useRouteContext();
  return (
    <div className="admin-divided space-y-4 max-w-5xl mx-auto">
      {/* Phones: the Admin title and page list (the sidebar does this on desktop) */}
      <AdminMobileNav userId={user?.id} isSuperAdmin={user?.role === "admin"} />

      {/* Child routes */}
      <Outlet />
    </div>
  );
}
